import React from 'react'
import { Alert, Button, Empty, Icon, Modal, Spin, Tooltip } from 'antd'
import moment from 'moment'

const TimelineExportsModal = ({
  visible,
  loading,
  error,
  exports = [],
  onClose,
  onRefresh
}) => (
  <Modal
    centered
    visible={visible}
    title="Timeline Exports"
    width={920}
    className="timeline-exports-modal"
    maskClosable={false}
    destroyOnClose
    onCancel={onClose}
    footer={[
      <Button key="refresh" icon="reload" loading={loading} onClick={onRefresh}>
        Refresh
      </Button>,
      <Button key="close" type="primary" onClick={onClose}>
        Close
      </Button>
    ]}
  >
    {loading ? (
      <div className="timeline-exports-modal__state">
        <Spin size="large" />
        <span className="timeline-exports-modal__state-text">
          Loading exported versions...
        </span>
      </div>
    ) : error ? (
      <Alert
        type="error"
        showIcon
        message="Could not load timeline exports"
        description={error}
      />
    ) : exports.length === 0 ? (
      <div className="timeline-exports-modal__state">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <span className="timeline-exports-modal__state-text">
              No timeline exports yet
            </span>
          }
        />
      </div>
    ) : (
      <div className="timeline-exports-list">
        {exports.map(item => (
          <article
            key={`${item.version}-${item.created_at || item.url}`}
            className="timeline-export-item"
          >
            <div className="timeline-export-item__preview-wrap">
              <video
                className="timeline-export-item__preview"
                src={item.url}
                preload="metadata"
                controls
              />
            </div>
            <div className="timeline-export-item__body">
              <div className="timeline-export-item__header">
                <strong className="timeline-export-item__version">
                  Version {item.version}
                </strong>
                <div className="timeline-export-item__meta">
                  <span className="timeline-export-item__tag">
                    {String(item.format || 'video').toUpperCase()}
                  </span>
                  {Number.isFinite(Number(item.duration)) && (
                    <span className="timeline-export-item__tag">
                      {Math.round(Number(item.duration))}s
                    </span>
                  )}
                  {Array.isArray(item.range) && (
                    <span className="timeline-export-item__tag">
                      {item.range[0]}s - {item.range[1]}s
                    </span>
                  )}
                </div>
              </div>
              <span className="timeline-export-item__date">
                {item.created_at
                  ? moment(item.created_at).format('MMM D, YYYY [at] h:mm A')
                  : 'Export date unavailable'}
              </span>
              <div className="timeline-export-item__actions">
                <Tooltip title="Download this export">
                  <Button
                    type="primary"
                    icon="download"
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download
                  </Button>
                </Tooltip>
              </div>
            </div>
          </article>
        ))}
      </div>
    )}
  </Modal>
)

export default TimelineExportsModal
